export var makeIndices=function makeIndices(start,delta,num){var indices=[];while(indices.length<num){indices.push(start);start+=delta;}return indices;};